import styled from 'styled-components';

import { Item as BaseItem } from './cart-entry.styled.default';

export * from './cart-entry.styled.default';

export const Item = styled(BaseItem)`
  p,
  h4 {
    font-size: 1rem;
  }
`;

export const ItemName = styled.h4`
  order: -3;
  flex: 1;
`;

export const ItemPrice = styled.div`
  order: -1;
`;

export const ItemQuantityBadge = styled.div<{ quantityText?: string }>`
  order: -2;
  margin-right: 2rem;
  &:before {
    content: ${({ quantityText = 'Qty: ' }) => quantityText};
  }
`;
